import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseConfiguration } from 'src/app/constants/constants/warehouse-api-config';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {
  BASE_DOMAIN = environment.BASE_DOMAIN
  
  constructor(private api : ApiService,private API_URL: WarehouseConfiguration, private http: HttpClient) { }

  getMethod(){
    const url = `${environment.ORDER_URL}${this.API_URL.CONFIG_URL.GET_CLIENTS_BY_ID}`;
    return this.api.get(url);
  }
  

  postMethod(user:any) {
    return this.api.post(this.BASE_DOMAIN+`${this.API_URL.CONFIG_URL.SIGNUP}`, user);
  }

  getWarehouseList(page:number, size: number, filter: any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.GET_WAREHOUSE_BY_FILTER}?pageNumber=${page}&pageSize=${size}`;
    return this.http.post<any>(url, filter);
  }

  addWarehouse(formData:any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.CREATE_WAREHOUSE_LOCATION}`;
    return this.http.post<any>(url, formData);
  }

  updateWarehouse(formData:any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.UPDATE_WAREHOUSE_LOCATION}`;
    return this.http.put<any>(url, formData);
  }

  getContainerList(page:number, size: number, filter: any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.GET_CONTAINER_BY_FILTER}?pageNumber=${page}&pageSize=${size}`;
    return this.http.post<any>(url, filter);
  }

  getBinList(page:number, size: number, filter: any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.GET_BIN_DETAILS}?pageNumber=${page}&pageSize=${size}`;
    return this.http.post<any>(url, filter);
  }

  getContainerStatus(){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.GET_CONTAINER_STATUS}`;
    return this.http.get<any>(url);
  }

  addContainer(formData:any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.ADD_CONTAINER}`;
    return this.http.post<any>(url, formData);
  }

  updateContainer(formData:any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.UPDATE_CONTAINER}`;
    return this.http.put<any>(url, formData);
  }

  getContainerType(){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.GET_CONTAINER_TYPE}`;
    return this.http.get<any>(url);
  }

  getWarehouseLayoutList(page:number, size: number, filter: any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.GET_WAREHOUSE_LAYOUT}?pageNumber=${page}&pageSize=${size}`;
    return this.http.post<any>(url, filter);
  }

  addWarehouseLayout(formData:any){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.ADD_WAREHOUSE_LAYOUT}`;
    return this.http.post<any>(url, formData);
  }

  addVendor(formData:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/vendor/createVendor`;
    return this.http.post<any>(url, formData);
  }

  getVendorList(formData:[], pageNumber:number, pageSize:number,sortingCol:any, direction:any){
      const url = (environment.New_BASE_DOMAIN + 'account-service/vendor/getVendorsDetail?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&direction=' + direction)
      return this.api.post(url,formData);
  }
  updateVendor(formData:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/vendor/updateVendor`;
    return this.http.put<any>(url, formData);
  }
  getVendorById(id:number) {
    const url = `${environment.New_BASE_DOMAIN}account-service/vendor/getVendorById?vendorId=${id}`;
    return this.api.get(url);
  }
  // downlaodTemplate(color:any){
  //   console.log(color)
  //   const url = `${environment.New_BASE_DOMAIN}/account-service/file/downloadTemplate?colorCode=${color}`
  //   return this.api.get(url);
  // }
  downlaodTemplate(type:any,colorCode:any){
    const url = `${environment.New_BASE_DOMAIN}utils-service/uploads/downloadTemplate?uploadType=${type}&colorCode=${colorCode}`
    return this.api.get(url);
}
  // getUploadHistory(data:any,pageNumber:any,pageSize:any){
  //   const url = `${environment.New_BASE_DOMAIN}account-service/file/getFileProgress?pageNumber=${pageNumber}&pageSize=${pageSize}`
  //     return this.api.post(url,data);
  // }

  getUploadHistory(data:any,pageNumber:any,pageSize:any){
    const url = `${environment.New_BASE_DOMAIN}utils-service/uploads/getFileDetails?pageNumber=${pageNumber}&pageSize=${pageSize}`
      return this.api.post(url,data);
  }
  upload(file: File,accountId:any,warehouseId:any,supplierId:any): Observable<HttpEvent<any>> {
    var url :any
    const formData: FormData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders({
      'VER': '1',
      'DEVICE-TYPE':'Web'
    });
    headers.append('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    url = `${environment.New_BASE_DOMAIN}utils-service/uploads/uploadFile?uploadType=MAPPING_PRODUCT`;

    const req = new HttpRequest('POST', url, formData, {
      headers,
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }


  getClientList(page:number, size: number, filter: any){
    const url = `${environment.New_BASE_DOMAIN}account-service/info/getAccountsDetail?pageNumber=${page}&pageSize=${size}`;
    return this.http.post<any>(url, filter);
  }
  createUpdateBin(data:any){
    const url = `${environment.New_BASE_DOMAIN}warehouse-service/locations/createBin`;
    return this.http.post<any>(url, data);
  }
  getAllLocationStockType(){
    const url = `${environment.New_BASE_DOMAIN}warehouse-service/master/getLocationStockType`;
    return this.http.get(url)
  }
  getAllLocationBinType(){
    const url = `${environment.New_BASE_DOMAIN}warehouse-service/master/getLocationBinType`;
    return this.http.get(url)
  }
  getLocationStatus(){
    const url = `${environment.New_BASE_DOMAIN}warehouse-service/master/getLocationStatus`;
    return this.http.get(url)
  }
  getZoneList(){
    const url = `${environment.New_BASE_DOMAIN}warehouse-service/master/getLocationZones`
    return this.http.get(url)
  }
  getActivePigeionhole(page:number, size: number, filter: any){
    const url = `${environment.New_BASE_DOMAIN}outbound-service/sort/getActivePigeonholes?pageNumber=${page}&pageSize=${size}`;
    return this.http.post<any>(url, filter);
  }
  freePigeionhole(picklistId:any,shipmentId:any,pigeonhole:any){
    const url = `${environment.New_BASE_DOMAIN}outbound-service/sort/freePigeonhole?picklistId=${picklistId}&shipmentId=${shipmentId}&pigeonhole=${pigeonhole}`;
    return this.http.post<any>(url, []);
  }
}
